import { Paper, TextField, Container, Box, Tabs, Tab, Button } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { updateKoriLisatieto, updateKoriAsiakasinfo, updateKoriOmistajainfo } from '@/services/koriService';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Container disableGutters>
          {children}
        </Container>
      )}
    </div>
  );
};

// Ilmeisesti jotain saatavuushommia
const a11yProps = (index) => {
  return {
    'id': `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const Lisatiedot = ({ data }) => {
  const [lisatiedot, setLisatiedot] = useState(data.lisatieto || 'Ei lisätietoja');
  const [asiakasinfo, setAsiakasinfo] = useState(data.asiakasinfo || 'Ei asiakasinfoa');
  const [omistajaInfo, setOmistajaInfo] = useState(data.omistajainfo || 'Ei omistajainfoa');
  const [tab, setTab] = useState(0);
  const { t } = useTranslation();

  const [lisatiedotEdited, setLisatiedotEdited] = useState(false);
  const [asiakasinfoEdited, setAsiakasinfoEdited] = useState(false);
  const [omistajaInfoEdited, setOmistajaInfoEdited] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleLisatietoChange = (val) => {
    setLisatiedot(val);
    setLisatiedotEdited(val !== (data.lisatieto || t('lisatiedot.noAdditionalInfo')));
  };

  const handleAsiakasinfoChange = (val) => {
    setAsiakasinfo(val);
    setAsiakasinfoEdited(val !== (data.asiakasinfo || t('lisatiedot.noCustomerInfo')));
  };

  const handleOmistajainfoChange = (val) => {
    setOmistajaInfo(val);
    setOmistajaInfoEdited(val !== (data.omistajainfo || t('lisatiedot.noOwnerInfo')));
  };

  const handleLisatietoSubmit = async (e) => {
    e.preventDefault();

    if (!lisatiedotEdited) {
      toast.info(t('lisatiedot.noChanges'));
      return;
    }

    try {
      await updateKoriLisatieto({
        id: data.koriIdOlio.id,
        updatedLisatieto: lisatiedot,
        originalLisatieto: data.lisatieto || '',
      });

      toast.success(t('lisatiedot.saved'));
      data.lisatieto = lisatiedot;
      setLisatiedotEdited(false);
    }
    catch (error) {
      toast.error(t('lisatiedot.saveError') + ' ' + error.message);
    }
  };

  const handleAsiakasinfoSubmit = async (e) => {
    e.preventDefault();

    if (!asiakasinfoEdited) {
      toast.info(t('lisatiedot.noChanges'));
      return;
    }

    try {
      await updateKoriAsiakasinfo({
        id: data.koriIdOlio.id,
        updatedAsiakasinfo: asiakasinfo,
        originalAsiakasinfo: data.asiakasinfo || '',
      });

      toast.success(t('lisatiedot.customerSaved'));
      data.asiakasinfo = asiakasinfo;
      setAsiakasinfoEdited(false);
    }
    catch (error) {
      toast.error(t('lisatiedot.customerSaveError') + ' ' + error.message);
    }
  };

  const handleOmistajainfoSubmit = async (e) => {
    e.preventDefault();

    if (!omistajaInfoEdited) {
      toast.info(t('lisatiedot.noChanges'));
      return;
    }

    try {
      await updateKoriOmistajainfo({
        id: data.koriIdOlio.id,
        updatedOmistajainfo: omistajaInfo,
        originalOmistajainfo: data.omistajainfo || '',
      });

      toast.success(t('lisatiedot.ownerSaved'));
      data.omistajainfo = omistajaInfo;
      setOmistajaInfoEdited(false);
    }
    catch (error) {
      toast.error(t('lisatiedot.ownerSaveError') + ' ' + error.message);
    }
  };

  return (
    <Box>
      <Box sx={{ borderTop: 1, borderColor: 'divider', justifyContent: 'center', display: 'flex' }}>
        <Tabs value={tab} onChange={handleTabChange} aria-label={t('lisatiedot.categories')}>
          <Tab label={t('lisatiedot.additionalInfo')} {...a11yProps(0)} />
          <Tab label={t('lisatiedot.customerInfo')} {...a11yProps(1)} />
          <Tab label={t('lisatiedot.ownerInfo')} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <Paper sx={{ p: '0.5em' }}>
          <form onSubmit={handleLisatietoSubmit}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              value={lisatiedot}
              onChange={e => handleLisatietoChange(e.target.value)}
              variant="outlined"
            />
            {lisatiedotEdited && (
              <Box sx={{ mt: 1 }}>
                <Button type="submit" variant="contained" color="primary">
                  {t('lisatiedot.save')}
                </Button>
              </Box>
            )}
          </form>
        </Paper>
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <Paper sx={{ p: '0.5em' }}>
          <form onSubmit={handleAsiakasinfoSubmit}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              value={asiakasinfo}
              onChange={e => handleAsiakasinfoChange(e.target.value)}
              variant="outlined"
            />
            {asiakasinfoEdited && (
              <Box sx={{ mt: 1 }}>
                <Button type="submit" variant="contained" color="primary">
                  {t('lisatiedot.save')}
                </Button>
              </Box>
            )}
          </form>
        </Paper>
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <Paper sx={{ p: '0.5em' }}>
          <form onSubmit={handleOmistajainfoSubmit}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              value={omistajaInfo}
              onChange={e => handleOmistajainfoChange(e.target.value)}
              variant="outlined"
            />
            {omistajaInfoEdited && (
              <Box sx={{ mt: 1 }}>
                <Button type="submit" variant="contained" color="primary">
                  {t('lisatiedot.save')}
                </Button>
              </Box>
            )}
          </form>
        </Paper>
      </TabPanel>
    </Box>
  );
};

export default Lisatiedot;
